import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { ReportsService } from '../../services/reports.service';
import { MatSidenav } from '@angular/material/sidenav';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { navData } from 'src/app/data/nav-data';

@Component({
  selector: 'vrm-resolve-alert',
  templateUrl: './vrm-resolve-alert.component.html',
  styleUrls: ['./vrm-resolve-alert.component.scss'],
})
export class VrmResolveAlertComponent implements OnInit {
  alertResolveForm: UntypedFormGroup;
  alertResolveAck: UntypedFormControl;
  alertActionsTaken: UntypedFormControl;
  alertResolveUpdate: UntypedFormControl;
  isUpdateButtonActive: boolean = false;

  @ViewChild('sidenav', { static: false }) sidenav: MatSidenav;

  constructor(
    private alertResolveFormBuilder: UntypedFormBuilder,
    public cService: CommonService,
    public rptService: ReportsService
  ) {
    this.buildResolveAlertForm();
    console.log('rpt servcie: ', this.rptService.selectedRows[0]);
  }

  ngOnInit() {
    this.initializeAlertResolveFormValues();
  }

  closeAlertResolveSideNav(): void {
    this.rptService.resolveAlertFailedSuggestions = [];
    this.rptService.resolveAlertAdditionalContent = null;
    this.rptService.resolveAlertDisplayAuthorisation = false;
    this.rptService.resolveAlertButtonText = this.cService.readyTranslations.alerts.resolveAlert;
    this.rptService.showReportSideNav = false;

    this.alertResolveAck.setValue(null);
    this.alertActionsTaken.setValue(null);
    this.isUpdateButtonActive = false;
  }

  submitAlertResolve(): void {
    const formData = Object.assign({}, this.alertResolveForm.value);
    const alertInfo = Object.assign({}, this.rptService.selectedRows[0]);

    this.isUpdateButtonActive = false;

    const postdata = {
      eventId: alertInfo.eventId,
      actionsTaken: formData.alertActionsTaken,
    };

    const secondaryPath = `reports/alerts/resolve`;

    this.rptService.sendAlertResolveRequest(secondaryPath, postdata).subscribe(
      (response) => {
        // Refresh this common report to reflect the change
        this.rptService.triggerDriverPerformanceDialogClosedObservable(this.rptService.endpointFilterValue, false);

        this.cService.showToast(this.cService.readyTranslations.alerts.alertResolved, 3000);

        // Reset the component values
        this.isUpdateButtonActive = false;
        this.rptService.resolveAlertFailedSuggestions = [];
        this.rptService.resolveAlertButtonText = this.cService.readyTranslations.alerts.resolveAlert;
        this.closeAlertResolveSideNav();

        // Refresh the alert count in the menu
        this.cService.triggerMenuBadgeCountUpdateObservable(navData.vrmAlerts.idName);
      },
      (error) => {
        this.cService.showToast(this.cService.readyTranslations.messagesAndWarnings.failedToProcessRequest, 3000);
        this.rptService.resolveAlertButtonText = this.cService.readyTranslations.form.retry;

        // Set error message to display on user interface
        const errStatus = error.responseStatus.substring(0, 3);
        let errToDisplay = this.cService.readyTranslations.messagesAndWarnings.failedToProcessData;
        if (errStatus == 400) {
          errToDisplay = this.cService.readyTranslations.alerts.actionsTakenEmpty;
        } else if (errStatus == 422) {
          errToDisplay = this.cService.readyTranslations.alerts.actionsTakenError;
        }

        this.rptService.resolveAlertFailedSuggestions = [errToDisplay];

        this.isUpdateButtonActive = true;
      }
    );
  }

  buildResolveAlertForm(): void {
    this.alertResolveForm = this.alertResolveFormBuilder.group({
      alertResolveAck: this.alertResolveFormBuilder.control(null),
      alertActionsTaken: this.alertResolveFormBuilder.control(null),
    });
  }

  initializeAlertResolveFormValues(): void {
    this.alertResolveAck = this.alertResolveForm.get('alertResolveAck') as UntypedFormControl;
    this.alertActionsTaken = this.alertResolveForm.get('alertActionsTaken') as UntypedFormControl;

    // set validation on tick box
    this.alertResolveAck.setValidators([Validators.requiredTrue]);

    //set validation on comments box
    this.alertActionsTaken.setValidators([Validators.required, Validators.minLength(1), Validators.maxLength(250)]);

    //Update/Submit button available only if form is valid
    this.alertResolveForm.statusChanges.subscribe((value) => {
      this.isUpdateButtonActive = value.toLowerCase() == 'valid' ? true : false;
    });

    this.alertActionsTaken.updateValueAndValidity();
  }
}
